// 用户模块
const User = {
	state: {
		networkState: true, //ture 外网 false 内网
		isLogin: false, // 是否登录
		logTime: "", // 登录时间
		token: "", // 邮件令牌
		//用户基本信息
		userInfo: {
			userId: "", // 用户名称
			userName: "", // 用户名称'
			account: "" // 邮件地址
		}
	},

	// 特别注意，子模块的mutations和getters、actions都是注册在全局store上的
	mutations: {
		// 更新用户信息
		updateUserInfo(state, payload) {
			state.userInfo = payload
		},
		updateNetworkState(state, data) {
			state.networkState = data
		}
	},
	getters: {}
}

export default User



// WEBPACK FOOTER //
// ./src/store/user.js